import {Dropdown, IDropdownStyles} from '@fluentui/react';
import React from "react";
import {connect} from "react-redux";

const dropdownStyles: Partial<IDropdownStyles> = {
    dropdown: { width: 200 }
};

class Confidentiality extends React.Component {

    constructor(props)
    {
        super(props);
        this.state = {
            editable: true,
            possibilities: [],
            choice: null
        }
    }

    change(e,v)
    {
        this.props.onUpdate("confidentiality", v.key);
    }

    componentDidMount(): void {
        // if(this.props.level === 'Strictly confidential') {
        //     this.setState({
        //         possibilities: [{
        //             key:this.props.level, 
        //             text: this.props.level
        //         }]
        //     });
        // }
        // else {
            const values = this.props.confidentialityLevels
              //  .filter(x => x.value !== 'Strictly confidential')
                .map(x => {
                    return {
                        key: x.value,
                        text: x.value
                    }
            });

            this.setState({
                possibilities: values
            })
      //  }
    }

    render() {
        return (
            <div style={{width:'100%', position:'relative'}}>
                <span> Confidentiality level </span>
                <div className="dropdown">
                <Dropdown
                    onChange={this.change.bind(this)}
                    disabled={this.props.disabled || this.props.isreadonly}
                    defaultSelectedKey={this.props.level}
                    options={this.state.possibilities}
                    styles={dropdownStyles}
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    confidentialityLevels: state.app.siteConfidentialityLevels
})

export default connect(mapStateToProps, null)(Confidentiality);



// WEBPACK FOOTER //
// ./src/components/EditSite/SiteEditElements/Confidentiality.js